import { initializeApp } from "firebase/app";
import firebase from "firebase/app";
import { getFirestore, collection, addDoc  } from "firebase/firestore"



// TODO: Add SDKs for Firebase products that you want to use

// https://firebase.google.com/docs/web/setup#available-libraries


// Your web app's Firebase configuration

// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const firebaseConfig = {

  apiKey: "AIzaSyABgOxckWP8Qx-J_ugpgS-WtX0nsxZ51FU",

  authDomain: "showcase-78956.firebaseapp.com",

  projectId: "showcase-78956",

  storageBucket: "showcase-78956.appspot.com",

  messagingSenderId: "1040788645800",

  appId: "1:1040788645800:web:7e33723b1f71ae79bedf9d",

  measurementId: "G-6VNKSEKDV7"

};


// Initialize Firebase





export const pushData = async (data:any)=>{
    const app = initializeApp(firebaseConfig);
    const db = getFirestore();
    const docRef = await addDoc(collection(db, "users"), data);
    return true;
}
